/////////////////////////////////////////////////V5CommentStart
// 2021-03-16 - Big Cleanup & fix of links and searching
// 2023-01-28 - research looking ok not fully flat yet
/////////////////////////////////////////////////V5CommentEnd 
import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import DataView from './DataView'
import Detroit from './Detroit'
import './DataView/Inventory.css'
import './FrontPage.css'
import { getFeaturedLinks } from '../utils/rest'
import Sentinel from './Sentinel'


class FeaturedLinks extends React.PureComponent {
  state = {}
  reload = false

  componentWillReceiveProps() {
    this.reload = true
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate() {
    if (this.reload) {
      this.load()
      this.reload = false
    }
  }

  load = () => {
    const { zipCode } = this.props
    if (!zipCode) return
    getFeaturedLinks(zipCode)
      .then(featuredLinks => this.setState({ featuredLinks }))
      .catch(err => {
        throw new Error(`FrontPage: Featured Links: ${err}`)
      })
  }

  featuredLinksMap = i => {
    if (this.state.featuredLinks.length === 0) return null
    if (i < 0 || i > this.state.featuredLinks.length) return null
    return (
      <Row className="teaser">
        <h3>{this.state.featuredLinks[i].title}</h3>
        {this.state.featuredLinks[i].links.map(({ url, title }) => (
          <Col key={url}>
            <Link to={url}>{title}</Link>
          </Col>
        ))}
      </Row>
    )
  }

  render() {
    if (!this.state.featuredLinks) return null
    return (
      <Grid fluid componentClass="aside" className="FeaturedLinks">
        <Row>
          <Col
            xs={5}
            xsOffset={1}
            sm={3}
            smOffset={2}
            md={2}
            mdOffset={1}
            lg={2}
            lgOffset={1}
          >
            {this.featuredLinksMap(0)}
          </Col>
          <Col xs={5} sm={3} md={2} lg={2}>
            {this.featuredLinksMap(1)}
          </Col>
          <Col xs={5} xsOffset={1} sm={3} smOffset={0} md={2} lg={2}>
            {this.featuredLinksMap(2)}
          </Col>
          <Col xs={5} sm={3} smOffset={2} md={2} mdOffset={0} lg={2}>
            {this.featuredLinksMap(3)}
          </Col>
          <Col xs={5} xsOffset={1} sm={3} smOffset={0} md={2} lg={2}>
            {this.featuredLinksMap(4)}
          </Col>
        </Row>
      </Grid>
    )
  }
}

class FeaturedInventory extends React.PureComponent {
  render() {
    if (!this.props.myLocationInfo.zipCode) return null
    const search = {
      ...this.props.app.state.myLocationInfo,
      ...this.props.app.searchAreaSupplemental,
      //NEWSTUFF
      ...this.props.app.state.myBasicParams,
      //NEWSTUFF      ipp: '5',
      //      page: '1',
    }
    return (
      <Grid componentClass="aside" className="DataView featured-content">
        <DataView.Inventory.Featured
          title="Popular Cars"
          {...this.props}
          search={search}
        />
      </Grid>
    )
  }
}

export default class FrontPage extends React.Component {
  render() {
    const { myLocationInfo = {} } = this.props
    return (

      <article className="FrontPage">
        <Sentinel>
          <Detroit {...this.props} widget="NEWDEAL" />
        </Sentinel>
        <Sentinel silent>
          <FeaturedInventory {...this.props} />
        </Sentinel>
        <Sentinel silent>
          <FeaturedLinks zipCode={myLocationInfo.zipCode} />
        </Sentinel>
      </article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FrontPage.js